module.exports = __webpack_public_path__ + "img/Demonstration_workshop.6e5a4ac9.png";